import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Navbar from "../navbar/Navbar";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import Footer from "../footer/footer";
import "./third.css";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0
  }
}));

export default function ControlledExpansionPanels() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Navbar />
      <Link to="/Notes" id="back">
        <Button
          style={{ margin: "10px", marginTop: "70px" }}
          variant="contained"
          color="primary"
          href="#contained-buttons"
        >
          <KeyboardBackspaceIcon />
        </Button>
      </Link>
      <h1 id="desc" style={{ textAlign: "center" }}>
        Third sem CSE/ISE Notes
      </h1>

      <ExpansionPanel
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        style={{ marginTop: "40px" }}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className={classes.heading}>Mathematics 3</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1ghLllfs0snSz_oCQc-ap98UfAQYu8TLg/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 1
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1HDTIO2_Rdq8Q7uvt_bD-WUt3yRsHbrei/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 2
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1akAZlD01EeUObn_4fguxVyFQNFZsw-fb/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 3
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1Vfkl0jaQ_FklmsckaExNHnK5439WBDcE/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 4
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1WN62usA9hJKtxsUqAYpT-OsRT-_-GGPG/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 5
              </a>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className={classes.heading}>ADE</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1yyQAc-1tzuP_ZeIf4WgZKTZWFzC1nRyC/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 1
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href=" https://drive.google.com/file/d/1TiZtj56BocorWMIyl_ZJOhcwf3xuCyzk/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 2
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1B6Ck_QU4tjMeZgcqjtJK4MErWtFhOjqc/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 3
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1WPLuUpUk1g2cdCFmqRXxRY-_1XNyVMZf/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 4
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href=" https://drive.google.com/file/d/19iEbntIdig6p_fcD-e3aL3_ZlQDAuVV1/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                                Module 5
              </a>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className={classes.heading}>DSA</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1vXtao6QcUquE2YVpvEqZr4nEc-rglTj-/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 1
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href=" https://drive.google.com/file/d/14zIYupKgzFzbNNR65lgDYXoW38G_HzDi/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 2
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1hc9bxpGFumIoWCqSRvDU0WyeWF7vMrr6/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 3
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href=" https://drive.google.com/file/d/1N65REqn4vGmmMNC9Jc5olJHYqxVQa69W/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 4
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1R7tfWidCaQwwclJGJII0MKAfjx_R6u4n/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                                         Module 5
              </a>
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>
            Computer Organisation
          </Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/19j7kIujtkODbHQYG1V50iLErQZJeq55z/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 1
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1kutc_B937PDkF6WNOmOhbTMaDTySdB82/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 2
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href=" https://drive.google.com/file/d/16YQBa027plBEsw9jc2ucMzKeEU2bIVte/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 3
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1cpBvuDHutNXYEG0CQ0DriljgSeoZJRWX/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 4
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href=" https://drive.google.com/file/d/1VaRjMry8AMl9ga8rX8fnlQwnnAV-bs75/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                                         Module 5
              </a>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: "20px" }}>
            <div style={{ color: "black" }}>
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1rTYfEZtrdbOlL4Gtm9bR2eOSAU9s_pUt/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 1 solutions
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1kahsdtdVdETWbIqMHuQMTFxGdwCQAOC4/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 2 solutions
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href=" https://drive.google.com/file/d/1dg1Ouqo0Q4P9OhX21aQEhGro-iZwcT4L/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 3 solutions
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1dg1Ouqo0Q4P9OhX21aQEhGro-iZwcT4L/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 4 solutions
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1Aw-yabp64tCSFUW4qIKh0EhisBTigxXo/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 5 solutions
              </a>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel5"}
        onChange={handleChange("panel5")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>
            Unix System Programming
          </Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1stKF2gjhgs7I7jyPxvPbIak6IJJHYmpi/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 1
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1F1JnxeXEahw_ttHrXG_Z7YBtPA3JDSNw/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 2
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1K8FusOEvVvmeYqE4ckcBe56P8QBdZ20A/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 3
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1Lda5hffnyDMQp89Ky_Q4Nz_PePelulIp/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 4
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1KSW3RIMg9XJZMYCbDiWkNCCah9USg_b_/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                                      Module 5
              </a>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel6"}
        onChange={handleChange("panel6")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>DMS</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1_9CzYONUD8GZ3R9B--S7qQmPyfER2Je6/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 1
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1MRlcX0jJDe2Qi9zCkjLdUVjoHIDxBuSh/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 2
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1VpP4iALtWKleqonxPvN6m_sZjRQJTyb1/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 3
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1Vp8xNvpTCcEK8nsb7RaflS10ExqEFcu8/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 4
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1Vq30p-vqC_-yJBmH65mbFB9CT5BPQynM/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                                              Module 5
              </a>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
              <a
                style={{ color: "black" }}
                href="https://drive.google.com/file/d/1V3pUgtsf7D-llTAB3pNxjp7HQ1iF0a_D/view?usp=sharing "
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 1 written notes
              </a>
              <br />
              <a
                style={{ color: "black" }}
                href=" https://drive.google.com/file/d/1Oi64dfFzmsv5dYV4RdLIzAtWqUd_k_3g/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                Module 5 written notes
              </a>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <h3 style={{ textAlign: "center", color: "blue" }}>
        Engage with our services below.
      </h3>

      <Footer />
    </div>
  );
}
